<script setup lang="ts">
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

withDefaults(
  defineProps<{
    href?: string
    label?: string
  }>(),
  {
    href: '/',
    label: 'Home',
  },
);

const cn = classNames('logo-link');
</script>

<template>
  <a :href="href" :class="cn()" :aria-label="label">
    <BaseIcon
      type="main"
      name="logo"
      :width="203"
      :height="86"
      :class="cn('logo')"
      aria-hidden="true"
    />
  </a>
</template>

<style lang="scss" scoped>
.logo-link {
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;

  @media (max-width: 768px) {
    &__logo {
      width: 177px;
      height: 74px;
    }
  }
}
</style>
